<template>
  <!-- Widget -->
  <section>
    <h4 v-if="!hideTitle">{{ customization.title || widget.name }}</h4>
    <div class="bg-white rounded px-1 d-flex flex-column" v-if="widget.dataOrigin">
      <LmDataTable :slug="widget.dataOrigin.slug" isOnWidgetMode />
      <LmButton
        class="align-self-end mr-2"
        buttonClass="btn-primary"
        value="Ver Más"
        @click="onClick"
      />
    </div>
    <div v-else>
      <h4>Configura tu widget</h4>
      <p>Selecciona una tabla de datos para el widget.</p>
    </div>
  </section>
</template>

<script>
// Base component
import LmDataTable from '@/components/lmDataTable/table'

// Components
import LmButton from '@/components/form/elements/LmButton'

export default {
  components: {
    LmDataTable,
    LmButton
  },
  props: {
    widget: {
      type: Object
    },
    customization: {
      type: Object
    },
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick () {
      this.$router.push(`/listado/${this.widget.dataOrigin.slug}`)
    }
  }
}
</script>
